import { useMemo } from 'react';

import { Box, Drawer, useMediaQuery, useTheme } from '@mui/material';

import DrawerContent from './DrawerContent';
import DrawerHeader from './DrawerHeader';
import MiniDrawerStyled from './MiniDrawerStyled';

import { drawerWidth } from 'themeConfig';

interface MainDrawerProps {
    open: boolean;
    handleDrawerToggle: () => void;
}

const MainDrawer = ({ open, handleDrawerToggle }: MainDrawerProps) => {
    const theme = useTheme();
    const matchDownMD = useMediaQuery(theme.breakpoints.down('lg'));

    const container = () => document.body;

    const drawerContent = useMemo(() => <DrawerContent />, []);
    const drawerHeader = useMemo(() => <DrawerHeader open={open} />, [open]);

    return (
        <Box component="nav" sx={{ flexShrink: { md: 0 }, zIndex: 1300 }} aria-label="mailbox folders">
            {!matchDownMD ? (
                <MiniDrawerStyled variant="permanent" open={open}>
                    <div data-locator="sidebarContainer">
                        {drawerHeader}
                        {drawerContent}
                    </div>
                </MiniDrawerStyled>
            ) : (
                <Drawer
                    container={container}
                    variant="temporary"
                    open={open}
                    onClose={handleDrawerToggle}
                    hideBackdrop={!open}
                    ModalProps={{
                        keepMounted: true,
                    }}
                    sx={{
                        display: { xs: 'block', lg: 'none' },
                        pointerEvents: open ? 'auto' : 'none',
                        '& .MuiDrawer-paper': {
                            boxSizing: 'border-box',
                            width: drawerWidth,
                            borderRight: `1px solid ${theme.palette.divider}`,
                            backgroundImage: 'none',
                            boxShadow: 'inherit',
                        },
                        '& .MuiBackdrop-root': {
                            display: open ? 'block' : 'none !important',
                            pointerEvents: open ? 'auto' : 'none !important',
                        },
                    }}
                >
                    <div data-locator="sidebarContainer">
                        {open && drawerHeader}
                        {open && drawerContent}
                    </div>
                </Drawer>
            )}
        </Box>
    );
};

export default MainDrawer;
